import React, { useMemo } from 'react';
import { Box, Typography } from '@mui/material';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';

interface ChangeIndicatorProps {
  change?: number | string;
  changeType?: string;
  colors: any; // ideally type this to your theme
  zeroText?: string; // optional override
}

export const ChangeIndicator: React.FC<ChangeIndicatorProps> = ({
  change,
  changeType,
  colors,
  zeroText = 'No change vs previous month',
}) => {
  const shouldShowChange =
    typeof change === 'number' &&
    (changeType === 'increase' || changeType === 'decrease');

  const content = useMemo(() => {
    if (!shouldShowChange) {
      return null;
    }

    if (change === 0) {
      return (
        <Box
          display="flex"
          alignItems="center"
          mt={1}
          sx={{ color: colors.widget.text.noChange }}
        >
          <Typography variant="bodyText" sx={{ ml: 0.5 }}>
            {zeroText}
          </Typography>
        </Box>
      );
    }

    const isIncrease = changeType === 'increase';

    return (
      <Box
        display="flex"
        alignItems="center"
        mt={1}
        sx={{
          color: isIncrease
            ? colors.widget.text.changeUp
            : colors.widget.text.changeDown,
        }}
      >
        {isIncrease ? (
          <ArrowUpwardIcon fontSize="small" />
        ) : (
          <ArrowDownwardIcon fontSize="small" />
        )}

        <Typography variant="bodyText" sx={{ ml: 0.5 }}>
          {change}% vs previous month
        </Typography>
      </Box>
    );
  }, [shouldShowChange, change, changeType, colors, zeroText]);

  return content;
};
